export default __webpack_public_path__ + "static/media/cdi-logo.fb85df70.png";